module.exports = __webpack_public_path__ + "img/31.3.TP.da5c7d7a.png";